/**
 * مدقّقات معاملات البحث (`validateSearch`) بلا zod.
 *
 * لماذا: كلّ مسار يستورد zod يجرّه إلى حزمة الدخول الأولى (~130KB خام)
 * ويُبطّئ أوّل رسم لكلّ زائر. هذه الدوالّ تغطّي ما نحتاجه فعلاً
 * (نصّ · منطقيّ · قائمة محصورة) بأسطر قليلة.
 */

export function optStr(v: unknown): string | undefined {
  // الراوتر يحوّل `?order=1072` إلى رقم، و`?t=0123` قد يصل رقماً أيضاً.
  // بدون هذا التطبيع تُسقَط أرقام الطلب القادمة من روابط الإيميل/واتساب.
  if (typeof v === "number" && Number.isFinite(v)) return String(v);
  if (typeof v === "bigint") return String(v);
  return typeof v === "string" && v.length > 0 ? v : undefined;
}


export function optBool(v: unknown): boolean | undefined {
  if (typeof v === "boolean") return v;
  if (v === "true") return true;
  if (v === "false") return false;
  return undefined;
}

/** يُرجع القيمة إن كانت من القائمة، وإلّا undefined. */
export function optEnum<const T extends readonly string[]>(
  v: unknown,
  options: T,
): T[number] | undefined {
  return typeof v === "string" && (options as readonly string[]).includes(v)
    ? (v as T[number])
    : undefined;
}

/** مثل optEnum لكن مع قيمة افتراضيّة. */
export function enumOr<const T extends readonly string[]>(
  v: unknown,
  options: T,
  fallback: T[number],
): T[number] {
  return optEnum(v, options) ?? fallback;
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function optUuid(v: unknown): string | undefined {
  return typeof v === "string" && UUID_RE.test(v) ? v : undefined;
}
